import { resolveErpIds } from "../filters/reducer";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getMarketingKpis,
    getMarketingLeadsMensuales,
    getMarketingPorFuente,
    getMarketingEmbudo,
    getMarketingCostePorLead,
    getMarketingParcial,
    getGscKpis,
    getGscEvolucion,
    getGscQueries,
    getGscPages,
} from '../../helpers/marketingApi';

const getFilters = (getState) => {
    const state = getState();
    return { empresaId: resolveErpIds(state), year: state.Filters.year };
};

export const getMarketingKpisData = createAsyncThunk(
    "dashboardMarketing/getKpis",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getMarketingKpis(empresaId, year);
    }
);

export const getMarketingLeadsMensualesData = createAsyncThunk(
    "dashboardMarketing/getLeadsMensuales",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getMarketingLeadsMensuales(empresaId, year);
    }
);

export const getMarketingPorFuenteData = createAsyncThunk(
    "dashboardMarketing/getPorFuente",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getMarketingPorFuente(empresaId, year);
    }
);

export const getMarketingEmbudoData = createAsyncThunk(
    "dashboardMarketing/getEmbudo",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getMarketingEmbudo(empresaId, year);
    }
);

export const getMarketingCostePorLeadData = createAsyncThunk(
    "dashboardMarketing/getCostePorLead",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getMarketingCostePorLead(empresaId, year);
    }
);

export const getMarketingParcialData = createAsyncThunk(
    "dashboardMarketing/getParcial",
    async (filtroParcial, { getState }) => {
        const { empresaId } = getFilters(getState);
        return await getMarketingParcial(empresaId, filtroParcial);
    }
);

export const getGscKpisData = createAsyncThunk(
    "dashboardMarketing/getGscKpis",
    async (periodo, { getState }) => {
        const { empresaId } = getState().Filters;
        return await getGscKpis(empresaId, periodo);
    }
);

export const getGscEvolucionData = createAsyncThunk(
    "dashboardMarketing/getGscEvolucion",
    async (periodo, { getState }) => {
        const { empresaId } = getState().Filters;
        return await getGscEvolucion(empresaId, periodo);
    }
);

export const getGscQueriesData = createAsyncThunk(
    "dashboardMarketing/getGscQueries",
    async (periodo, { getState }) => {
        const { empresaId } = getState().Filters;
        return await getGscQueries(empresaId, periodo);
    }
);

export const getGscPagesData = createAsyncThunk(
    "dashboardMarketing/getGscPages",
    async (periodo, { getState }) => {
        const { empresaId } = getState().Filters;
        return await getGscPages(empresaId, periodo);
    }
);
